<template>
  <div class="addmodal fixed w-full h-screen z-20 top-0 left-0 flex justify-center items-start overflow-auto">
    <div class="bg-white m-auto w-9/12 md:w-7/12 h-auto flex flex-col rounded-md justify-center items-center">
      <h2
        class="font-costea w-11/12 px-2 py-1 my-4 mx-auto border-b border-gray-200 text-left text-t20 font-medium text-costeaBlack">
        Editar área
      </h2>
      <div class="bg-gray-200 w-11/12 h-24 rounded-md relative mb-4"
        :style="`background-repeat: no-repeat; background-size: contain; background-position:center center; ${showImage}`">
        <span @click="$refs.myFiles.click()"
          class="cursor-pointer flex flex-row items-center justify-center absolute bg-costeaPrimary text-white w-10 h-10 right-4 bottom-4 rounded-full">
          <i class="ri-camera-fill text-lg"></i>
          <input type="file" @input="pickFile" @change="onSelectedImage" ref="myFiles"
            accept="image/png, image/jpeg, image/jpg" style="display:none" />
        </span>
      </div>
      <p v-if="errorSizeImage" class="text-costeaSalmon font-costea text-t12 text-left w-11/12 bg-costeaSalmonDisabled px-2 py-1 rounded-md ">{{ this.errorSizeImage }}</p>
      <form @submit.prevent="updateAreas" class="flex flex-col justify-start items-center w-11/12">
        <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-full rounded-md">
            <p for="nombre" class="w-full text-costeaGray items-center content-center text-t16 mb-1">Nombre del área: *
            </p>
            <input id="nombre" type="text" name="nombre" :value="areaOld" @input="changeAreaOld" required
              class="bg-white placeholder-gray-500 border-gray-400 border outline-none font-costea px-2 p-2 text-t16 w-full rounded-md tracking-wide"
              :placeholder="areaOld">
          </div>
        </div>

        <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
          <div class="mb-2 px-2 py-2 flex flex-row content-center items-center w-10/12 sm:w-8/12 rounded-md">
            <div class="w-5/12 mr-2">
              <p for="diasHabiles" class="w-full text-costeaGray items-center content-center text-t16 mb-1">Días hábiles
                al mes: *</p>
              <input id="diasHabiles" type="number" min="0" max="30" name="diasHabiles" :value="diasMes"
                @input="changeDiasMes" required
                class="bg-white placeholder-gray-500 border-gray-400 border outline-none font-costea px-2 p-2 text-t16 w-full rounded-md tracking-wide"
                :placeholder="diasMes">
            </div>
            <div class="w-5/12">
              <p for="horasDia" class="w-full text-costeaGray items-center content-center text-t16 mb-1">Horas por día:
                *</p>
              <input id="horasDia" type="number" min="0" max="24" name="horasDia" :value="this.horasDia"
                @input="changeHorasDia" required
                class="bg-white placeholder-gray-500 border-gray-400 border outline-none font-costea px-2 p-2 text-t16 w-full rounded-md tracking-wide"
                :placeholder="horasDia">
            </div>
          </div>
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-end w-10/12 sm:w-4/12 rounded-md">
            <p class="w-full text-costeaGray items-center content-center text-t16 mb-1 text-right">Horas hombre
              disponibles al mes:</p>
            <p>{{ this.getHorasHombre }} </p>
          </div>
        </div>

        <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
          <div class="mb-2 px-2 py-2 flex flex-row content-center items-center w-10/12 sm:w-8/12 rounded-md">
            <div class="w-10/12">
              <p for="costoArea" class="w-full text-costeaGray items-center content-center text-t16 mb-1">Costo total
                del área: *</p>
              <span class="bg-white border border-gray-400 flex justify-center items-center px-2 rounded-md">
                $
                <input id="costoArea" name="costoArea" type="number" min="0" max="999999999" step="0.01"
                  :value="costoTotalArea" @input="changeCostoTotalArea" required
                  class="bg-white border-white placeholder-gray-500 border outline-none font-costea px-2 p-2 text-t16 w-full tracking-wide"
                  :placeholder="costoTotalArea">
              </span>
            </div>

          </div>
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-end w-10/12 sm:w-4/12 rounded-md">
            <p class="w-full text-costeaGray items-center content-center text-t16 mb-1 text-right">Costo hora hombre:
            </p>
            <p>$ {{ interNumberFormat(this.getCostoHorasHombre) }}</p>
          </div>
        </div>

        <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
          <div class="mb-2 px-2 py-2 flex flex-row content-center items-center w-10/12 sm:w-8/12 rounded-md">
            <div class="w-5/12">
              <p for="numPersonas" class="w-full text-costeaGray items-center content-center text-t16 mb-1">N° de
                personas: *</p>
              <input id="numPersonas" name="numPersonas" type="number" min="0" max="999" step="1" :value="numPersonas"
                @input="changeNumPersonas" required
                class="bg-white placeholder-gray-500 border-gray-400 border outline-none font-costea px-2 p-2 text-t16 w-full rounded-md tracking-wide"
                :placeholder="this.numPersonas">
            </div>

          </div>
        </div>

        <div class="mb-4 p-2 flex content-center items-center w-10/12 rounded-md justify-end">
          <button
            class="bg-costeaBtn2 rounded-md text-costeaPrimary hover:bg-costeaBtn2Hover duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide mr-4"
            @click="toggleModal()" type="button">Cancelar</button>
          <input @click="onProcess()"
            :class="'rounded-md text-white hover:bg-costeaHover duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide ml-4 ' + buttonBg"
            type="submit" :value="buttonText" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      buttonText: 'Actualizar',
      buttonBg: 'bg-costeaPrimary',
      modalAct: true,

      area: [],
      dataAreaOld: '',
      dataIdArea: '',
      dataCostoTotalArea: '',
      dataDiasMes: '',
      dataHorasDia: '',
      dataHorasHombre: '',
      dataCostoHoraHombre: '',
      dataNumPersonas: '',

      picture: null,
      previewImage: null,

      errorSizeImage: '',
    }
  },

  computed: {
    ...mapState(['costea']),
    getHorasHombre() {
      let diasHabiles = this.diasMes
      let horasDia = this.horasDia
      let horas = diasHabiles * horasDia
      return horas
    },
    getCostoHorasHombre() {
      let totalCostoArea = this.costoTotalArea
      let horasDisponiblesMes = this.getHorasHombre
      let trabajadoresArea = this.numPersonas
      let costo = totalCostoArea / (horasDisponiblesMes * trabajadoresArea)
      costo = costo.toFixed(2)
      return costo
    },
    showImage() {
      if (this.previewImage != null) {
        return `background-image:url('${this.previewImage}');`
      } else {
        return 'background-color: #f1f2f3;'
      }
    },
  },
  props: ['areaOld', 'idArea', 'costoTotalArea', 'diasMes', 'horasDia', 'horasHombre', 'costoHoraHombre', 'numPersonas', 'img'],
  methods: {
    interNumberFormat(number) {
      let interNF = new Intl.NumberFormat('es-CO');
      let numberDecimals = parseFloat(number)
      numberDecimals = numberDecimals.toFixed(2)
      return interNF.format(numberDecimals)
    },
    changeNumPersonas(event) {
      this.dataNumPersonas = event.target.value;
    },
    changeAreaOld(event) {
      this.dataAreaOld = event.target.value
    },
    changeDiasMes(event) {
      this.dataDiasMes = event.target.value
    },
    changeHorasDia(event) {
      this.dataHorasDia = event.target.value
    },
    changeCostoTotalArea(event) {
      this.dataCostoTotalArea = event.target.value
    },
    updateAreas: function () {
      this.errorSizeImage = ''
      if (this.picture && this.picture.size > 450000) {
        this.errorSizeImage = 'El tamaño de la imagen no puede ser mayor a 450kb'
        this.buttonText = 'Actualizar'
        return
      }
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let formData = new FormData()
      formData.append('id', this.idArea)

      if (this.picture != null) { formData.append('picture', this.picture) }
      formData.append('name', this.dataAreaOld != '' ? this.dataAreaOld : this.areaOld);
      formData.append('dias_habiles_mes', this.dataDiasMes != '' ? parseInt(this.dataDiasMes) : this.diasMes)
      formData.append('horas_por_dia', this.dataHorasDia != '' ? parseInt(this.dataHorasDia) : this.horasDia)
      formData.append('horas_hombre_por_mes', parseInt(this.getHorasHombre))
      formData.append('costo_total_del_area', this.dataCostoTotalArea != '' ? parseFloat(this.dataCostoTotalArea) : this.costoTotalArea)
      formData.append('numero_de_personas', this.dataNumPersonas != '' ? parseInt(this.dataNumPersonas) : this.numPersonas)
      axios
        .post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}areasempresa-update/${this.idArea}`, formData, config)
        .then(() => {
          setTimeout(() => {
            this.buttonText = 'Listo!'
            this.buttonBg = 'bg-costeaDarkGreen'

          }, 100)
          setTimeout(() => {
            this.toggleModal()
          }, 1000)
          setTimeout(() => {
            this.buttonText = 'Editar'
            this.buttonBg = 'bg-costeaPrimary'
          }, 3000)
        }
        ).catch(
          (error) => {
            console.log(error)
          }
        );
    },
    getCostoHoras(costoArea, horasMes, trabajadores) {
      let total = costoArea / (horasMes * trabajadores)
      total = total.toFixed(2)
      return total
    },
    modalActive() {
      this.modalAct = true
      this.modalAct == true ? this.modalAct = false : this.modalAct = true
      return this.modalAct
    },
    toggleModal() {
      this.$emit('closeModalEdit', this.modalActive())
      this.$emit('reloadData', true)
    },
    onProcess() {
      this.buttonText = 'Editando...'
    },
    onSelectedImage(event) {
      this.picture = event.target.files[0]
    },
    pickFile() {
      let input = this.$refs.myFiles
      let file = input.files
      if (file && file[0]) {
        let reader = new FileReader
        reader.onload = e => {
          this.previewImage = e.target.result
        }
        reader.readAsDataURL(file[0])
      }
    },

  },
  created() {

  }
}
</script>

<style scoped>
.addmodal {
  background: rgba(0, 0, 0, 0.6);
}
</style>